{
  "actions": "Działania",
  "hideButtonLabel": "Wyświetl mniej",
  "showAllButtonLabel": "Pokaż wszystko ({tagCount, number})"
}
